import { Instance, types } from 'mobx-state-tree';

export const PhoneValidation = types.model('PhoneValidation', {
  phoneRegularExpression: types.string,
  internationalMode: types.boolean
});

export type PhoneValidation = Instance<typeof PhoneValidation>;
